import {setLoad} from '../../main';
import axios from "axios";
// import Cookies from 'js-cookie'
// import {STATS_ROLES} from "../../config/constants";

const SALES_STATS_ENDPOINT = 'sync/sales_stats';

let streamsIntervalId = null;

const getDefaultState = () => {
  return {
    salesStatsEndpoint: SALES_STATS_ENDPOINT,
    "streams": {
      "products": [
        {
          "label": null,
          "value": null
        },

      ],
      "shifts": [
        {
          "active": null,
          "created_at": null,
          "description": null,
          "goal": null,
          "icon": null,
          "id": null,
          "name": null,
          "updated_at": null
        },


      ],
      "statistic": {
        "company": {
          "daily": {
            "count": 54,
            "days": {
              "remaining": null,
              "working": null
            },
            "goal": null,
            "gross_sale": null,
            "net_sale": null
          },
          "last_sale": {
            "amount": null,
            "at": null,
            "is_sale": false,
            "product": null,
            "user_id": null,
            "uuid": null
          },
          "monthly": {
            "count": null,
            "days": {
              "remaining": null,
              "working": null
            },
            "goal": null,
            "gross_sale": null,
            "net_sale": null
          },
          "weekly": {
            "count": null,
            "days": {
              "remaining": null,
              "working": null
            },
            "goal": null,
            "gross_sale": null,
            "net_sale": null
          }
        },
        "products": [
          {
            "daily_count": null,
            "gross_daily_sale": null,
            "gross_monthly_sale": null,
            "gross_weekly_sale": null,
            "monthly_count": null,
            "net_daily_sale": null,
            "net_monthly_sale": null,
            "net_weekly_sale": null,
            "product": null,
            "weekly_count": null
          },
        ],


        "shifts": [

          {
            "agents": [],
            "daily": {
              "count": null,
              "days": {
                "remaining": null,
                "working": null
              },
              "goal": null,
              "gross_sale": null,
              "net_sale": null
            },
            "id": null,
            "last_sale": {
              "amount": null,
              "at": null,
              "is_sale": false,
              "product": null,
              "user_id": null,
              "uuid": null
            },
            "monthly": {
              "count": null,
              "days": {
                "remaining": null,
                "working": null
              },
              "goal": null,
              "gross_sale": null,
              "net_sale": null
            },
            "name": null,
            "weekly": {
              "count": null,
              "days": {
                "remaining": null,
                "working": null
              },
              "goal": null,
              "gross_sale": null,
              "net_sale": null
            }
          },

        ],
        "users": [

          {
            "avatar": null,
            "crm_id": null,
            "daily": {
              "count": null,
              "days": {
                "remaining": null,
                "working": null
              },
              "goal": null,
              "gross_sale": null,
              "net_sale": null
            },
            "id": null,
            "monthly": {
              "count": null,
              "days": {
                "remaining": null,
                "working": null
              },
              "goal": null,
              "gross_sale": null,
              "net_sale": null
            },
            "shifts": null,
            "username": null,
            "weekly": {
              "count": null,
              "days": {
                "remaining": null,
                "working": null
              },
              "goal": null,
              "gross_sale": null,
              "net_sale": null
            }
          },

        ]
      },
      "users": {
        "5": {
          "agent_code": null,
          "application": null,
          "avatar": null,
          "commission_from": null,
          "commission_to": null,
          "commission_type": null,
          "created_at": null,
          "crm_api_key": null,
          "crm_id": null,
          "dial_code": null,
          "email": null,
          "extension_code": null,
          "full_name": null,
          "id": null,
          "is_blocked": true,
          "level_id": null,
          "level_points": null,
          "monthly_goal": null,
          "points": null,
          "role": null,
          "updated_at": null,
          "username": null
        },
      }
    }
  };
}

const state = getDefaultState();

const RUN_API_INTERVAL = 900000;

const mutations = {
  SET_SALES_STATS_ENDPOINT: (state, endpoint) => {
    state.salesStatsEndpoint = endpoint;
  },
  SET_STREAM: (state, {streams}) => {
    let dUsers = streams.users;
    let users = {};
    for (let key in dUsers) {
      let k = dUsers[key].id;
      users[k] = dUsers[key];
    }
    streams.users = users;
    state.streams = streams;
  },
  replace(state, data) {
    // data.data.socket = 1;
    let dUsers = data.users;
    let users = {};
    for (let key in dUsers) {
      let k = dUsers[key].id;
      users[k] = dUsers[key];
    }
    data.users = users;
    Object.assign(state.streams, data);
  }
};

const actions = {
  setSalesStatsEndpoint: ({commit, state}, endpoint) => {
    if (state.salesStatsEndpoint === endpoint) {
      return;
    }

    commit('SET_SALES_STATS_ENDPOINT', endpoint);

    if (streamsIntervalId) {
      clearInterval(streamsIntervalId);
      streamsIntervalId = null;
    }
  },
  getStreams: ({dispatch, state}) => {
      // const role = Cookies.get('user-role');

      // if ( STATS_ROLES.includes(role) ) {
          dispatch('getStreamsNew');

          if (streamsIntervalId) {
            clearInterval(streamsIntervalId);
          }

          streamsIntervalId = setInterval(() => {
              dispatch('getStreamsNew');
          }, RUN_API_INTERVAL);
      // } else {
      //     dispatch('getStreamsOld');
      // }
  },
  getStreamsOld: ({commit}) => {
    return axios(
      {url: 'sync/streams/dynamic_boards_stream', method: 'GET'}
    ).then((resp) => {
      let streams = resp.data;
      commit('SET_STREAM', { streams });
      setLoad(0);
    });
  },
  getStreamsNew: ({commit, state}) => {
    return axios(
      {url: state.salesStatsEndpoint, method: 'GET'}
    ).then((resp) => {
      let streams = resp.data;
      commit('SET_STREAM', { streams });
      setLoad(0);
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
